import React, { Component } from 'react'
import PropTypes from 'prop-types'

import NextButton, { BackButton } from '../../common/NextButton'
import LocationRow from './LocationRow'
import {
  validateEmailMappings,
  mapContactInfo,
} from './contact-info-validations'

class Associations extends Component {
  static propTypes = {
    businesses: PropTypes.arrayOf(PropTypes.object).isRequired,
    doctors: PropTypes.arrayOf(PropTypes.object).isRequired,
    buyPhoneNumbers: PropTypes.func.isRequired,
    extensions: PropTypes.objectOf(
      PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    ).isRequired,
    hasErrors: PropTypes.bool.isRequired,
    isTopsAdmin: PropTypes.bool.isRequired,
    locations: PropTypes.arrayOf(PropTypes.object).isRequired,
    onBack: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    pms: PropTypes.string.isRequired,
    products: PropTypes.arrayOf(PropTypes.string).isRequired,
    refetchLocations: PropTypes.func.isRequired,
    showAdditionalRecipients: PropTypes.bool.isRequired,
    showDoctorSelect: PropTypes.bool.isRequired,
    tier: PropTypes.number.isRequired,
  }

  constructor(props) {
    super(props)
    const {
      locations,
      extensions: { location_extensions: selectedExtensions },
    } = props
    const contactInfoMaps = mapContactInfo(locations)

    this.state = {
      contactInfoMaps,
      emailsValidation: validateEmailMappings(contactInfoMaps),
      selectedExtensions,
    }

    this.handleFinish = this.handleFinish.bind(this)
  }

  handleFinish = () => {
    const { onFinish, hasErrors, onNext } = this.props
    const { contactInfoMaps, selectedExtensions } = this.state
    onNext(contactInfoMaps, selectedExtensions).then(() => {
      if (!hasErrors) onFinish()
    })
  }

  updateExtensions = (locationId, extensionIds) => {
    const { selectedExtensions: oldSelectedExtensions } = this.state
    const updatedExtensions = oldSelectedExtensions
    updatedExtensions[locationId] = extensionIds
    this.setState({
      selectedExtensions: updatedExtensions,
    })
  }

  saveContactInfo = (locationId, contactObj) => {
    const { contactInfoMaps } = this.state
    const curr = contactInfoMaps[locationId] || {}
    const nextContactInfoMaps = {
      ...contactInfoMaps,
      [locationId]: { ...curr, ...contactObj },
    }

    const emailsValidation = validateEmailMappings(
      nextContactInfoMaps,
      locationId,
    )

    this.setState({ contactInfoMaps: nextContactInfoMaps, emailsValidation })
  }

  saveLocationActive = (locationId, isActive) => {
    const contactInfoMapsNew = this.state.contactInfoMaps
    contactInfoMapsNew[locationId].active = isActive
    this.setState({ contactInfoMaps: contactInfoMapsNew })
  }

  render() {
    const {
      businesses,
      buyPhoneNumbers,
      doctors,
      isTopsAdmin,
      extensions: {
        available_extensions: availableExtensions,
        location_extensions: locationExtensions,
      },
      locations,
      onBack,
      pms,
      products,
      refetchLocations,
      showAdditionalRecipients,
      showDoctorSelect,
      tier,
    } = this.props
    const { contactInfoMaps, emailsValidation } = this.state

    const dso = products && products.indexOf('dso') > -1
    const voip = products && products.indexOf('voip') > -1

    return (
      <div>
        <h3>Locations</h3>
        <p>
          Note: Whenever you purchase a phone number, please fill in the contact
          info for that location within 5 minutes
        </p>
        {locations.map(location => (
          <LocationRow
            availableExtensions={availableExtensions || []}
            businesses={businesses}
            buyPhoneNumbers={buyPhoneNumbers}
            contactInfo={contactInfoMaps[location.id]}
            doctors={doctors}
            dso={dso}
            emailsValidation={emailsValidation}
            isTopsAdmin={isTopsAdmin}
            key={location.id}
            location={location}
            locations={locations}
            messageReportEmails={
              contactInfoMaps[location.id].messageReportEmails
            }
            pms={pms}
            purchasedNumbers={
              location.phone_numbers || contactInfoMaps[location.id].numbers
            }
            refetchLocations={refetchLocations}
            requiresPhoneNumberPurchase={tier !== 4}
            saveContactInfo={this.saveContactInfo}
            saveLocationActive={this.saveLocationActive}
            selectedExtensions={
              locationExtensions ? locationExtensions[location.id] : []
            }
            showAdditionalRecipients={showAdditionalRecipients}
            showDoctorSelect={showDoctorSelect}
            smseUsers={location.smse_users}
            updateExtensions={this.updateExtensions}
            voip={voip}
          />
        ))}
        <BackButton handleClick={onBack} />
        <NextButton
          label="finish"
          isSubmit={false}
          handleClick={this.handleFinish}
        />
      </div>
    )
  }
}

export default Associations



// WEBPACK FOOTER //
// ./src/AddPractice/Associations/index.js